React = require 'react'
t = require('views/internal/recup-with-helpers')('manage_members')
track = require 'debug/track'
PopOver = require 'views/lib/pop-over'
OrganizationLinkGAHelperView = require 'views/organization/organization-link-ga-helper-view'

module.exports = class extends React.Component
  displayName: 'LinkGoogleApps'

  constructor: (props) ->
    super(props)

  render: t.renderable ->
    t.div {
      class: t.classify('link-google-apps-with-summary': @props.showBillingSummary)
      onClick: @startLinkingGoogleApps
    }, ->
      t.div '.pop-over-ad.business-class-ad', ->
        t.img '.icon-google-g.pop-over-ad-icon', { src: require('images/services/google-g-logo.svg') }
        t.div '.ad-copy', ->
          t.span '.title', -> t.format 'using-google-apps'
          t.span '.learn-more', -> t.format 'link-google-apps-domain'

  startLinkingGoogleApps: (el) =>
    track("Organization View", "Members Page", "Start Linking Google Apps Domain")

    { model, modelCache } = @props

    PopOver.pushView
      view: OrganizationLinkGAHelperView
      options: { model, modelCache }


// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/link-google-apps.coffee